import { init, fireAnalyticsEvent } from './core';
import { firePageLoadEvents } from './pageLoadEvents';
export { fireAnalyticsEvent } from './core';

window.webAnalytics.ready().then(({ response, timestamp, timedOut }) => {
  if (timedOut) {
    devWarn('Analytics Hub: Web Analytics initialize timed out:', timedOut);
    return;
  }
  devLog('Analytics Hub: Web Analytics initialized:', response, new Date(timestamp));

  init();
  firePageLoadEvents();
});

window.analyticsHub = {
  fireAnalyticsEvent: fireAnalyticsEvent
};